import { useMemo } from 'react'
import { useFeatureFlags } from 'features/FeatureFlags'

import { useOutstandingFilterContext } from '../../context/useOutstandingFilterContext'
import { useGetOutstandingExpensesFilter } from './useGetOutstandingExpensesFilter/useGetOutstandingExpensesFilter'

export const useGetOutstandingFilter = () => {
  const flags = useFeatureFlags()
  const { isOutstandingFilterOn } = useOutstandingFilterContext()
  const { isOutstandingExpensesFilterOn } = useGetOutstandingExpensesFilter()

  const isFilterOn = useMemo(() => {
    if (!flags.CorpCardsOutstandingTransactionsFilter) {
      return false
    }

    return flags.CorpCardsSettings
      ? isOutstandingFilterOn
      : isOutstandingExpensesFilterOn
  }, [
    flags.CorpCardsOutstandingTransactionsFilter,
    flags.CorpCardsSettings,
    isOutstandingFilterOn,
    isOutstandingExpensesFilterOn,
  ])

  return {
    isFilterOn,
  }
}
